import React, { useCallback, useEffect } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import "../../assets/styles/layout-styles.scss";
import "../../assets/styles/common-styles.scss";
import { NavLink } from "react-router-dom";
import { useNav } from "./useNav";
import Cookies from "js-cookie";
import { decodeToken } from "../../utils/decodeToken";
import { useAppDispatch } from "../../store";
import { setUserObj } from "../../store/slices/commonSlice";
import PermissionCheck from "../common/PermissionCheck/PermissionCheck";
const DashboardPage: React.FunctionComponent<any> = () => {
  const dispatch = useAppDispatch();
  const token = Cookies.get("accessToken");

  const getUserProfile = useCallback(() => {
    const tokenDetails = decodeToken(token);
    const { userDetails } = tokenDetails;
    dispatch(setUserObj(userDetails));
  }, [token]);

  useEffect(() => {
    getUserProfile();
  }, [token]);

  const { listItems } = useNav();
  return (
    <>
      <Box>
        <CssBaseline />
        <Box className="projectNameinLeftNav">
          <Typography variant="h3" className="textWhite fw700">
            KITT
          </Typography>
        </Box>
        <aside className="leftBar">
          <List className="leftNav" component="nav" aria-labelledby="Menu">
            {listItems.map((item, index) => (
              <PermissionCheck
                permission={item.permission ? item?.permission : "true"}
                key={index}
              >
                <NavLink to={item.path}>
                  <ListItemButton>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                </NavLink>
              </PermissionCheck>
            ))}
          </List>
        </aside>
      </Box>
    </>
  );
};
export default DashboardPage;
